export type QuestionType = 'text' | 'textarea' | 'number' | 'yesno' | 'select';

export interface QuestionnaireQuestion {
  key: string;
  label: string;
  type: QuestionType;
  options?: string[];
}

// Placeholder question set — replace with the final questionnaire. Answers are stored by `key`,
// so keep keys stable once assessments exist.
export const HOSPITAL_QUESTIONNAIRE: QuestionnaireQuestion[] = [
  {key: 'hospitalType', label: 'Type of hospital', type: 'select', options: ['Government', 'Private', 'Trust / Charitable']},
  {key: 'bedCapacity', label: 'Total bed capacity', type: 'number'},
  {key: 'pediatricWard', label: 'Dedicated paediatric ward available?', type: 'yesno'},
  {key: 'oncologyFacility', label: 'Oncology / specialised treatment facility available?', type: 'yesno'},
  {key: 'patientsPerMonth', label: 'Approx. children referred per month', type: 'number'},
  {key: 'accommodationNearby', label: 'Patient accommodation available nearby?', type: 'yesno'},
  {key: 'swSupport', label: 'Social worker support level', type: 'select', options: ['None', 'Limited', 'Adequate', 'Strong']},
  {key: 'coordinationQuality', label: 'Quality of coordination with hospital staff', type: 'select', options: ['Poor', 'Average', 'Good', 'Excellent']},
  {key: 'challenges', label: 'Key challenges observed', type: 'textarea'},
  {key: 'recommendations', label: 'Recommendations / next steps', type: 'textarea'}
];

export interface AssessmentChange {
  question: string;
  from: any;
  to: any;
}
